import { render, staticRenderFns } from "./shieldtest.vue?vue&type=template&id=1b3a2827&"
import script from "./shieldtest.vue?vue&type=script&lang=js&"
export * from "./shieldtest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports